import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const FreeReturns: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    viewBox="0 0 164 139"
    xmlns="http://www.w3.org/2000/svg"
    className={cn(s.svg, 'svg-icon--free-return')}
    version="1.1"
    data-icon={icon}
  >
    <g
      fill="#000"
      transform="translate(-77.70, -16.00)"
      fillRule="nonzero"
      stroke="#FFF"
      strokeWidth="2.75"
    >
      <path d="M176.5 21.561l59.5 45.42v82.58H117v-24.775h8.5v16.517h102V70.78l-51-38.317-51 38.317v12.717H117V66.981l59.5-45.42z" />
      <path d="M102.009 127.561l-19.009-23 19.009-23 6.597 5.11L97.2 100.471H156v8.178l-58.8.001 11.406 13.801-6.597 5.11z" />
    </g>
  </svg>
);

export default FreeReturns;
